import axios from "axios";

export const API_URL = "https://srinivasafleet.com/api";


const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login?reason=session_revoked";
      }
    }
    return Promise.reject(error);
  }
);

export const getDrivers = async (status = "all") => {
  const response = await api.get("/drivers/", { params: { status } });
  return response.data;
};

export const getFinancialYears = async () => {
  const res = await api.get("/auth/financial-years");
  return res.data;
};
export const extractFileName = (storedValue) => {
  if (!storedValue) return "";
  return storedValue.split("/").pop().split("?")[0];
};
export const fetchDriverFile = async (fileKey) => {
  const filename = extractFileName(fileKey);
  const response = await api.get("/drivers/download", {
    params: { path: filename },
    responseType: "blob",
  });
  return response.data; 
};

export const createDriver = async (data) => {
  const response = await api.post("/drivers/", data);
  return response.data;
};

export const getDriverById = async (id) => {
  const response = await api.get(`/drivers/${id}`);
  return response.data;
};

export const updateDriver = async (id, payload) => {
  const response = await api.put(`/drivers/${id}`, payload);
  return response.data;
};

export const deleteDriver = async (id) => {
  const response = await api.delete(`/drivers/${id}`);
  return response.data;
};

export const getStatuses = async () => {
  const response = await api.get("/vehicles/master/status");
  return response.data;
};

export const getLocations = async () => {
  const res = await api.get("drivers/master-service-locations");
  return res.data;
};

export const getBranches = async (locationId) => {
  const res = await api.get("drivers/master-branch", {
    params: locationId ? { location_id: locationId } : {},
  });
  return res.data;
};

export const getSupplierType = async () => {
  const res = await api.get("drivers/master-supplier-type/");
  return res.data;
};

export const getDriverDocuments = async (driverId) => {
  const response = await api.get(`/drivers/${driverId}/documents`);
  return response.data;
};

export const uploadDriverDocument = async (driverId, field, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post(
    `/drivers/${driverId}/upload-document?field=${field}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};